import { DeleteImageBirthdayParams } from "./paramsTypes";

export const getAccountInfoUrl = "portal-person-info/profile/account-info";

export const postChangeAvatarUrl = "portal-person-info/profile/avatar";

export const postChangeImageBirthdayUrl =
  "portal-person-info/profile/avatar/birthday";

export const deleteImageBirthdayUrl = ({
  screenCode,
  itemCode,
  masterAccount,
}: DeleteImageBirthdayParams) =>
  `portal-person-info/profile/${screenCode}/${itemCode}/${masterAccount}/avatar/birthday`;

export const rolesMenuUrl = "/portal-auth/permission/screen";

export const permissionItemUrl = (screenCode: string) =>
  `/portal-auth/permission/${screenCode}/item`;
